import { Map } from 'components/Shared/ProductJourney';
import Logo from 'images/seedtrace_logo_wordmark_black.svg';
import React from 'react';
import styled from 'styled-components';
const SeedtraceWrapper = styled.div `
  position: absolute;
  bottom: 4px;
  left: 8px;
  width: 63px;
`;
const MapBoundary = styled.div `
  position: relative;
  height: ${({ height }) => height}px;
  width: 100%;
  overflow: hidden;
  border-radius: 6px;

  .mapboxgl-ctrl-group {
    display: none;
  }

  .mapboxgl-map {
    .mapboxgl-ctrl-bottom-left {
      bottom: -4px;
      right: 0;
      left: auto;
      transform: scale(0.8);
    }

    .mapboxgl-ctrl-bottom-right {
      bottom: -5px;
      right: 70px;
      transform: scale(0.8);
    }
  }
`;
const PreviewMapComponent = ({ width = 200, height = 200, }) => {
    return (React.createElement("div", null,
        React.createElement(MapBoundary, { height: height, id: "st-preview-button-map" },
            React.createElement(Map, { isSummaryMap: true, width: width }),
            React.createElement(SeedtraceWrapper, null,
                React.createElement(Logo, null)))));
};
export default PreviewMapComponent;
